import React from 'react';
import ActivityItem from '../atoms/ActivityItem';
import './ActivityList.css';

interface Activity {
  type: 'order' | 'product' | 'customer';
  title: string;
  description: string;
  time: string;
}

interface ActivityListProps {
  activities: Activity[];
}

const ActivityList: React.FC<ActivityListProps> = ({ activities }) => {
  return (
    <div className="activity-list">
      {activities.map((activity, index) => (
        <ActivityItem
          key={index}
          type={activity.type}
          title={activity.title}
          description={activity.description}
          time={activity.time}
        />
      ))}
    </div>
  );
};

export default ActivityList;
